export const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatPeriodLabel = (year, month) => {
  if (!year || !month) return '-';
  return new Date(year, month - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};

export const normalizeOwnerCode = (value) => String(value || '').trim().toUpperCase();

export const getOwnerCodeFromItem = (item) => normalizeOwnerCode(item?.owner_code || item?.data?.owner_code);

export const buildDefaultInvoiceNotes = (periodLabel) => (
  periodLabel ? `Monthly invoice for the month of ${periodLabel}` : 'Monthly invoice'
);

export const getApiErrorMessage = (err, fallbackMessage) => (
  err?.response?.data?.message
  || err?.response?.data?.error
  || err?.message
  || fallbackMessage
);

export const getInvoiceStatusLabel = (item) => {
  const data = item?.data || {};
  const invoiceStatus = String(data.invoice_status || '').toUpperCase();

  if (data.invoice_ref) {
    if (invoiceStatus === 'DRAFT') return 'Draft';
    if (invoiceStatus === 'SENT') return 'Sent';
    if (invoiceStatus === 'PAID') return 'Paid';
    return 'Posted';
  }

  return item?.success ? 'Ready to Invoice' : 'Skipped';
};

export const getInvoiceStatusClass = (item) => {
  const data = item?.data || {};
  const invoiceStatus = String(data.invoice_status || '').toUpperCase();

  if (data.invoice_ref) {
    if (invoiceStatus === 'DRAFT') return 'bg-slate-100 text-slate-700';
    if (invoiceStatus === 'SENT') return 'bg-emerald-100 text-emerald-800';
    if (invoiceStatus === 'PAID') return 'bg-blue-100 text-blue-800';
    return 'bg-slate-200 text-slate-700';
  }

  return item?.success ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-700';
};
